import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import {
  getLaborCostDetails,
  laborCostDetailsQueryKey,
} from "@/pages/human-resources/time-management/endpoints/LaborCostDetailsEndpoint";
import type { LaborCostDetailsIn } from "@/pages/human-resources/time-management/endpoints/analysis/inout/LaborCostDetailsIn.ts";
import type { LaborCostSection } from "@/pages/human-resources/time-management/business/analysis/LaborCostSection.ts";
import { mapToLaborCostSection } from "@/pages/human-resources/time-management/endpoints/analysis/inout/LaborCostSectionOut.ts";

export function useReadLaborCostDetails(
  params: LaborCostDetailsIn,
  enabled: boolean,
): UseQueryResult<LaborCostSection[]> {
  return useQuery<LaborCostSection[]>({
    queryKey: laborCostDetailsQueryKey.forSiteAndDate(params),
    queryFn: async () =>
      (await getLaborCostDetails(params)).map(mapToLaborCostSection),
    enabled,
  });
}
